import { useFadeIn } from '@hooks/useFadeIn'
import { projects } from '@content/portfolioData'
import { archiveProjects } from '@content/archiveProjects'

export function Projects({ onOpenArchive }: { onOpenArchive: () => void }) {
  const fade = useFadeIn()

  return (
    <section id="projects" ref={fade.ref as React.RefObject<HTMLElement>} className={`modern-section ${fade.className}`}>
      <p className="modern-section__label">Projects</p>
      <h2 className="modern-section__title">Featured work</h2>
      <div className="modern-projects__grid">
        {projects.map((project) => (
          <article key={project.name} className="modern-card">
            <div className="modern-card__header">
              <h3 className="modern-card__name">{project.name}</h3>
              <span className="modern-card__status">{project.status}</span>
            </div>
            <p className="modern-card__tagline">{project.tagline}</p>
            <p className="modern-card__desc">{project.description}</p>
            {project.url && (
              <a
                className="modern-card__link"
                href={project.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                Visit live site
                <span aria-hidden="true"> ↗</span>
              </a>
            )}
            {project.screenshots.length > 0 && (
              <div className="modern-card__screenshots">
                {project.screenshots.map((src) => (
                  <img
                    key={src}
                    src={src}
                    alt={`${project.name} screenshot`}
                    className="modern-card__screenshot"
                    loading="lazy"
                  />
                ))}
              </div>
            )}
            {project.embedUrl && (
              <iframe
                src={project.embedUrl}
                title={`${project.name} live playlist`}
                className="modern-card__embed"
                loading="lazy"
                allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
                allowFullScreen
              />
            )}
            <div className="modern-card__tech">
              {project.tech.map((t) => (
                <span key={t} className="modern-card__tech-tag">{t}</span>
              ))}
            </div>
            {(project.metrics || project.lesson) && (
              <details className="modern-card__details">
                <summary className="modern-card__details-summary">Case study</summary>
                {project.metrics && project.metrics.length > 0 && (
                  <ul className="modern-card__metrics">
                    {project.metrics.map((m) => (
                      <li key={m} className="modern-card__metric">{m}</li>
                    ))}
                  </ul>
                )}
                {project.lesson && (
                  <p className="modern-card__lesson">{project.lesson}</p>
                )}
              </details>
            )}
          </article>
        ))}
      </div>
      <button
        type="button"
        className="modern-btn modern-btn--secondary modern-projects__archive-btn"
        onClick={onOpenArchive}
      >
        View all {archiveProjects.length} projects &rarr;
      </button>
    </section>
  )
}
